import { contains } from 'ramda'
import { RoutePath } from '../enums/Routes'

export const isNonAuthPage = (path: string): boolean =>
  contains(RoutePath.AUTH, path)
